export default __webpack_public_path__ + "static/media/SaleIcon.6d2a27a3.svg";